module.exports = __webpack_public_path__ + "static/img/hg2.afcb64b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hg2.jpg
// module id = jlZf
// module chunks = 1